var _style, _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4Descending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:#1C3C6B;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 20,
    height: 20
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.8,7l-1.7-2.5c-0.1-0.2-0.3-0.2-0.5-0.1c-0.1,0.1-0.1,0.1-0.2,0.2l-0.3,0.9l-15.8-5C0.9,0.3,0.4,0.5,0.3,1 L0.2,1.2c-0.1,0.4,0.1,0.9,0.5,1l15.8,5l-0.3,1c-0.1,0.2,0,0.4,0.2,0.5c0.1,0,0.2,0,0.3,0l2.8-1.1C19.8,7.5,19.9,7.2,19.8,7 C19.8,7,19.8,7,19.8,7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,10.1h1.1c0.4,0,0.7,0.3,0.7,0.7v8c0,0.4-0.3,0.7-0.7,0.7H8.8c-0.4,0-0.7-0.3-0.7-0.7v-8 C8.1,10.4,8.4,10.1,8.8,10.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.7,6.8h1.1c0.4,0,0.7,0.3,0.7,0.7v11.3c0,0.4-0.3,0.7-0.7,0.7H1.7c-0.4,0-0.7-0.3-0.7-0.7V7.6 C1,7.1,1.3,6.8,1.7,6.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,12.3h1.1c0.4,0,0.7,0.3,0.7,0.7v5.8c0,0.4-0.3,0.7-0.7,0.7h-1.1c-0.4,0-0.7-0.3-0.7-0.7V13 C14.9,12.6,15.2,12.3,15.6,12.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Descending);
export default __webpack_public_path__ + "static/media/4_Descending.2bd41dd0543863f768afe34afe1d2d87.svg";
export { ForwardRef as ReactComponent };